import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";

const Industry = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});
    
    let response36 = useInvoke("WebApps", "36", {});
    
    const[rows, setRows] = useState([]);
    const[columns, setColumns] = useState([]);

    useEffect(() => {
        if (response36.data.payload != undefined) {
            let myData = JSON.parse(response36.data.payload).data;
            let rowsList = [];

            myData.forEach((entry, index) => { 

              let row = [
                {type: "link", content: {text: `${entry[1]}`, link: `/Industry/Edit/${entry[0]}`}}, 
                {type: "text", content: {text: `${entry[2]}`}},
                {type: "text", content: {text: `${entry[3]}`}}
              ];
              rowsList.push(row);
            });

            setColumns(["Industry Name", "NAICS Code", "Date Added"]);
            setRows(rowsList);

        }

    }, [response36.data.payload]);

    document.title = "Industries";
    return ( 
        <div className="industries">
            {user["email"] != undefined && 
                <>
                    <div className="container" style={{margin: "auto"}}>
                        <h2>Industries</h2>
                        <p><Link className="btn btn-primary" to="/Industry/New">New Industry</Link></p>
                    
                        {(columns && rows) && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} />}

                    </div>
                </>
            }
        </div>
     );
}
 
export default Industry;